import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import {
    makeStyles,
    Button,
    Grid,
    MenuItem,
} from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { setLoading } from 'redux/actions/app';
import * as API from 'services/api';
import { CustomTextInput, CustomCommonSelect, CustomDatePicker } from 'components'
import SaveIcon from '@material-ui/icons/Save';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import { showMessage } from 'utils';
import ModalWrap from 'components/Modals/ModalWrap';

const useStyles = makeStyles(theme => ({
    field: {
        marginBottom: theme.spacing(1),
    },
    icon: {
        width: theme.spacing(2),
        height: theme.spacing(2),
        marginRight: theme.spacing(1)
    },
    saveBtn: {
        borderRadius: theme.spacing(1),
        marginRight: theme.spacing(1)
    },
}));

const ActionModal = ({
    intl: { formatMessage },
    visible,
    onClose,
}) => {
    const classes = useStyles();
    const [formState, setFormState] = useState({
        gender: '',
        firstName: '',
        lastName: '',
        birth: '',
    });

    const dispatch = useDispatch();

    const onFieldChange = event => {
        if (event.persist) {
            event.persist();
        }
        setFormState(formState => ({
            ...formState,
            [event.target.name]: event.target.value,
        }));
    };

    const isDisabled = Object.keys(formState)
        .map(key => formState[key] === '')
        .reduce((e1, e2) => e1 || e2, false);

    const onSubmit = () => {
        dispatch(setLoading(true));
        API.createEmployee(formState)
            .then(res => {
                dispatch(setLoading(false));
                if (res.code == 201) {
                    onClose(true)
                    showMessage({
                        message: 'created successfully!',
                        type: 'success'
                    });
                }
            })
            .catch(() => {
                dispatch(setLoading(false));
            });
    };

    return (
        <ModalWrap
            title={formatMessage({ id: "employee.add" })}
            open={visible}
            closeModal={() => onClose()}
        >
            {Object.keys(formState).map(key => {
                if (key === 'birth') {
                    return (
                        <CustomDatePicker
                            key={key}
                            variant="outlined"
                            autoOk={true}
                            label={formatMessage({ id: "employee.birth" })}
                            fullWidth
                            inputVariant="outlined"
                            disableToolbar
                            format="DD/MM/YYYY"
                            name="birth"
                            defaultValue={formState.date || null}
                            value={formState.date || null}
                            onChange={date => {
                                setFormState(formState => ({
                                    ...formState,
                                    birth: date,
                                }));
                            }}
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                            InputProps={{ endAdornment: <CalendarTodayIcon /> }}
                            clearable
                            maxDate={new Date()}
                        />
                    );
                }
                if (key === 'gender') {
                    return (
                        <CustomCommonSelect
                            select
                            className={classes.field}
                            fullWidth
                            variant="outlined"
                            key={key}
                            name={key}
                            value={formState[key]}
                            onChange={onFieldChange}
                            label={formatMessage({
                                id: `employee.${key}`,
                            })}
                        //error={formState[key] === ''}
                        >
                            <MenuItem key={"female"} value={"female"} style={{ backgroundColor: 'white' }}>
                                {formatMessage({ id: "cart.gender.female" })}
                            </MenuItem>
                            <MenuItem key={"male"} value={"male"} style={{ backgroundColor: 'white' }}>
                                {formatMessage({ id: "cart.gender.male" })}
                            </MenuItem>
                        </CustomCommonSelect>
                    );
                }
                return (
                    <CustomTextInput
                        className={classes.field}
                        fullWidth
                        variant="outlined"
                        key={key}
                        name={key}
                        value={formState[key]}
                        onChange={onFieldChange}
                        label={formatMessage({
                            id: `employee.${key}`,
                        })}
                    //error={formState[key] === ''}
                    />
                );
            })}
            <br />
            <Grid container justify='flex-end'>
                <Button variant="contained" onClick={onSubmit} disabled={isDisabled} color="primary" className={classes.saveBtn}>
                    <SaveIcon className={classes.icon} />
                    <FormattedMessage id="save" />
                </Button>
            </Grid>
        </ModalWrap>
    );
};

ActionModal.propTypes = {
    intl: PropTypes.shape({
        formatMessage: PropTypes.func.isRequired,
    }),
    visible: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
};

ActionModal.defaultProps = {
    actionId: null,
};

export default injectIntl(ActionModal);
